import React from 'react';
import { Button } from '@salesforce/design-system-react';
import logo from '../../images/logo-dark.svg';
import styles from './Navbar.module.scss';
import {useAppSelector} from '../../app/hooks';
import {selectReport} from '../dashboard/dashboardSlice';

export const Navbar: React.FC = () => {
  const onLogout = () => {
    localStorage.clear();
    window.location.reload();
  };
  const report = useAppSelector(selectReport);
  const username = report?.organization.username;
  return (
    <div className={styles.Navbar}>
      <a href="https://flosum.com/">
        <img alt={''} src={logo} className={styles.NavbarLogo} />
      </a>
      <Button className={styles.ButtonNavbar} label='Logout' variant='brand' onClick={onLogout} />
      <span className={styles.NavbarUsername}>{username}</span>
    </div>
  );
}
